export { default } from "./FeaturedBet";
